import { ChangeDetectionStrategy, Component } from '@angular/core';

// The Loading texts card's body on the Test UI Components page: the rotating text spinner.
@Component({
  selector: 'cs-test-loading-texts-card',
  host: { class: 'showcase-card-body' },
  template: `
    <cs-text-spinner data-test="text-spinner"></cs-text-spinner>
  `,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestLoadingTextsCardComponent {}
